
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { v4 as uuid } from 'uuid';

import FormInput from '@/components/form/NewFormInput.vue';
import Processing from '@/components/common/Processing.vue';
import FormGroupError from '@/components/form/FormGroupError.vue';

@Component({
	components: {
		FormGroupError,
		FormInput,
		Processing,
	},
})
export default class FormGroup extends Vue {
	@Prop({ type: [String, Number], default: undefined }) readonly value!:
		| string
		| number;
	@Prop({ type: String, default: undefined }) readonly id?: string;

	@Prop({ type: String, default: undefined }) readonly placeholder?: string;
	@Prop({ type: Array, default: () => [] }) readonly errors!: string[];
	@Prop({ type: String, default: undefined }) readonly name?: string;
	@Prop({ type: String, default: undefined }) readonly title?: string;
	@Prop({ type: String, default: 'text' }) readonly type!: string;
	@Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
	@Prop({ type: Boolean, default: false }) readonly processing!: boolean;
	@Prop({ type: String, default: undefined }) readonly inputClass?: string;
	@Prop({ type: String, default: '' }) readonly formInputClass!: string;
	@Prop({ type: Number, default: 0 }) readonly debounceTime!: number;
	@Prop({ type: String, default: undefined }) readonly height?: string;
	@Prop({ type: Boolean, default: false })
	readonly allowOnlyAlphanumeric!: boolean;

	get labelShown(): boolean {
		const labelComponentUsed = Boolean(this.$scopedSlots.title);
		const titleUsed = Boolean(this.title);
		return labelComponentUsed || titleUsed;
	}

	get inputClasses(): Object {
		return {
			'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300':
				this.hasErrors,
			'focus:border-primary': !this.hasErrors,
		};
	}

	get titleClasses(): Object {
		return {
			'text-sm text-gray-90': true,
			'text-red-500 font-medium font-bold': this.hasErrors,
			'ml-1': this.title,
		};
	}
	get inputId(): string {
		return this.id ? this.id : uuid();
	}

	get hasErrors(): boolean {
		return this.errors.length > 0;
	}
	filterAlphanumeric(value: string): string {
		return value.replace(/[^a-zA-Z0-9]/g, '');
	}

	handleInput(value: any): void {
		let val = value;
		if (this.allowOnlyAlphanumeric) {
			val = this.filterAlphanumeric(val);
		}
		this.$emit('input', val);
	}

	@Watch('hasErrors')
	emitHasErrors(): void {
		this.$emit('hasErrors', this.hasErrors);
	}
}
